/*
 * @Author: 40463 jia.rong.li@hand-china.com
 * @Date: 2024-12-16 11:44:39
 * @LastEditors: 40463 jia.rong.li@hand-china.com
 * @LastEditTime: 2025-01-09 15:28:58
 * @FilePath: \dq-wxpa\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import FastClick from 'fastclick'
import App from './App'
import router from './router' // 导入新创建的 router.js
import './global.css';
Vue.config.productionTip = false

// 使用 FastClick 解决移动端点击延迟问题
FastClick.attach(document.body)

/* eslint-disable no-new */
new Vue({
  router, // 将 router 传入 Vue 实例
  render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js